import React from 'react'
import { Label } from 'components'

const ProfileLabel = props => (
  <Label className="block text-xs text-white opacity-70 mb-2 uppercase" {...props} />
)

export default ProfileLabel
